/* istanbul ignore file */
import KatalLogger, { Level } from "@amzn/katal-logger";

const katalLoggerConfig = {
  url: "https://09gw7lzlj0.execute-api.us-east-1.amazonaws.com/prod/v1/log",
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: false,
};

export const logger = new KatalLogger(katalLoggerConfig);
logger.addErrorListener();

// Console debugging logs
// @ts-ignore - Stage is replaced at build time by webpack
// TODO [Before Launch] - Verify debug logs are not shown in production
const isProd = 'prod' === 'prod';
export const debug = isProd ? () => {} : console.debug.bind(console);
